module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-11.6023125f.png";